// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareToQrCheckboxLabel_container__GqRjE","bold":"ShareToQrCheckboxLabel_bold__Pz7cF"};